import React from "react"
import { Layout, SEO, Contact } from "../components";
import { Images } from "../theme"

const IndexPage = () => (
  <Layout>
    <div className="pgcus">
    <SEO title="Contact US | Natural Silver Solutions" description="Natural Silver Solutions. Professional Bio-Active colloidal silver supplement, delivers advantages no other manufacturer can match."/>
            <div className="fx fxdr fxjcc fxaic">
                <div className="w50">
                    <div className="pd15">  
                    <Contact/>
                </div>
                </div>
                <div className="w50">
                    <div className="pd15">  
                    <h5>Follow Us on Social Media:</h5>
                      <div className="scnet">
                        <ul>
                            <li><a href="https://www.facebook.com/#" target="_blank" rel="noopener noreferrer">
                            <img src={Images.fbo} alt="facebook" /></a></li>
                            <li><a href="https://twitter.com/#" target="_blank" rel="noopener noreferrer">
                            <img src={Images.twto} alt="twitter" /></a></li>
                            <li><a href="https://www.youtube.com/channel/#" target="_blank" rel="noopener noreferrer">
                            <img src={Images.yto} alt="youtube" /></a></li>
                            <li><a href="https://www.instagram.com/#" target="_blank" rel="noopener noreferrer">
                            <img src={Images.ino} alt="instagram" /></a></li>
                        </ul>
                    </div>
                    <h5>Our Contact Info:</h5>
                    <div className="coinfo">
                        <div>
                          <span role="img" aria-label="Phone">☎️ </span>
                          <span> 
                            <strong>Phone Number:</strong>
                            <a href="tel:+116129165275"> +1 161 2916 5275</a>
                          </span>
                          </div>
                        <div>
                          <span role="img" aria-label="Email">✉️ </span>
                          <span> 
                            <strong>Email Address:</strong>
                             <a href="mailto:info@naturalsilversolution.com"> info@naturalsilversolution.com</a>
                             </span>
                        </div>
                        <div>
                          <span role="img" aria-label="Office">🏢 </span>
                          <span><strong>Office location:</strong></span>
                          <span> Kigali City, Gasabo District. Ndera Sector (Special Economic Zone)</span>
                        </div>
                    </div>                        
                    </div>
                </div>
            </div>          
    </div>
  </Layout>
)

export default IndexPage
